import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, $, Slot } from "@builder.io/qwik";
import { modalContextId } from "./modal-context.qwik.mjs";
const HModalTrigger = component$((props) => {
  const context = useContext(modalContextId);
  const handleClick$ = $(() => {
    context.showSig.value = !context.showSig.value;
  });
  return /* @__PURE__ */ jsx("button", {
    "aria-haspopup": "dialog",
    "aria-expanded": context.showSig.value,
    "data-open": context.showSig.value ? "" : void 0,
    "data-closed": !context.showSig.value ? "" : void 0,
    onClick$: [
      handleClick$,
      props.onClick$
    ],
    ...props,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HModalTrigger
};
